import { StackProps, VStack } from "@chakra-ui/react";
import Pusher from "pusher-js";
import { useEffect, useState } from "react";
import { ListChatInterface } from "../../constants/Chat";
import useCustomToast from "../../lib/useCustomToast";
import { useGetUserLoginStore } from "../../store/useGetUserLoginStore";
import { useDarkWhiteColor } from "../../themes/colors";
import { getAxiosInstance } from "../../utils/helperFunction";
import { TitlePageDashboard } from "../button/TitlePageDashboard";
import SearchInput from "../input/SearchInput";
import { CardChat } from "./CardChat";

interface Props extends StackProps {
  onSelectedChat: (selectedChat: any) => void;
}

export const ListChat = ({ onSelectedChat, ...rest }: Props) => {
  const [data, setData] = useState<ListChatInterface[]>([]);
  const [search, setSearch] = useState<string>("");
  const [filteredChatList, setFilteredChatList] = useState(data);
  const bgBnw = useDarkWhiteColor();
  const { currentActiveUser: user } = useGetUserLoginStore();
  const toast = useCustomToast();

  useEffect(() => {
    const pusher = new Pusher(process.env.REACT_APP_PUSHER_APP_KEY!, {
      cluster: process.env.REACT_APP_PUSHER_APP_CLUSTER!,
      forceTLS: true,
    });

    let channel = undefined;
    if (user?.id) {
      const subsribedChannel = `list-chat.${user.id}.${user.role}`;
      channel = pusher.subscribe(subsribedChannel);

      if (channel) {
        channel.bind("ListMessages", (dataMsg: any) => {
          if (Array.isArray(dataMsg)) {
            setData(dataMsg);
          }
        });
      }
    }

    return () => {
      if (channel) {
        const subsribedChannel = `list-chat.${user?.id}.${user?.role}`;
        channel.unbind("ListMessages");

        pusher.unsubscribe(subsribedChannel);
      }
    };
  }, [user?.id, user?.role]);

  useEffect(() => {
    setFilteredChatList(
      data?.filter((item) =>
        item.name.toLowerCase().includes(search.toLowerCase())
      )
    );
  }, [search, data]);

  useEffect(() => {
    let pageType = 1; //buyer

    if (user) {
      if (user?.role === "supplier") {
        pageType = 3;
      }

      const axiosInstance = getAxiosInstance(pageType);
      axiosInstance
        .get(`/v1/chat/list-${user.role}-chat/${user?.id}?search=${search}`)
        .then((res) => {
          setData(res.data.data);
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {});
    }
  }, [user]);

  return (
    <VStack
      className="left-chat-layout"
      w={"30%"}
      px={4}
      bg={bgBnw}
      align={"stretch"}
      overflowY={"auto"}
      {...rest}
    >
      <TitlePageDashboard title="Chat" />

      <SearchInput
        placeholder={getPlaceholder(user?.role || "")}
        onConfirm={(searchQuery) => {
          setSearch(searchQuery);
        }}
      />

      <VStack
        className="list-chat-container"
        w={"100%"}
        mt={4}
        overflowY={"auto"}
      >
        {filteredChatList?.map((item, i) => (
          <CardChat
            key={i}
            item={item}
            onClick={() => onSelectedChat(item.id_chat)}
          />
        ))}
      </VStack>
    </VStack>
  );
};

const getPlaceholder = (role: string) => {
  switch (role) {
    case "buyer":
      return "Cari Toko...";
    case "supplier":
      return "Cari Pelanggan...";
    default:
      return "Cari Pengguna...";
  }
};
